import { Typography } from 'antd'
import { type ParagraphProps as AntdParagraphProps } from 'antd/lib/typography/Paragraph'
import clsx from 'clsx'
import { forwardRef } from 'react'
import styles from './styles.module.scss'

export interface ParagraphProps extends AntdParagraphProps {
  noMargin?: boolean
}

export const Paragraph = forwardRef<HTMLDivElement, ParagraphProps>(
  ({ noMargin, className, ...props }, ref) => {
    return (
      <Typography.Paragraph
        {...props}
        className={clsx(className, { [styles.noMargin]: noMargin })}
        ref={ref}
      />
    )
  },
)
